import Button from '@mui/material/Button'
import React, { useRef, useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { OrderProduct } from '../../entities/order-product/OrderProduct'
import Modal from '../modal/Modal'
import ProductControlSwitcher from '../product-control-switcher/ProductControlSwitcher'
import ProductDeclineButton from '../product-decline-button/ProductDeclineButton'
import ProductItem from '../product-item/ProductItem'
import { PageLoader } from '../PageLoader/PageLoader'
import messages from './ProductIncomingModal.messages'

export interface IOwnProps {
  product: OrderProduct
  open: boolean
  onClose: () => void
}

export interface IStateProps {
  acceptLoading?: boolean
}

export interface IDispatchProps {
  requestProductAccept: (product: OrderProduct, onEnd?: () => void) => void
}

export type IProps = IOwnProps & IStateProps & IDispatchProps

const ProductIncomingModal: React.FC<IProps> = (props) => {
  const {
    product,
    open,
    onClose,
    acceptLoading = false,
    requestProductAccept,
  } = props

  // Ref to track if component is mounted
  const isMountedRef = useRef(true)

  useEffect(() => {
    isMountedRef.current = true
    return () => {
      isMountedRef.current = false
    }
  }, [])

  const handleAcceptClick = () => {
    requestProductAccept(product, () => {
      setTimeout(() => {
        // Only close modal if component is still mounted
        if (isMountedRef.current) {
          onClose()
        }
      }, 500)
    })
  }

  return (
    <>
      <PageLoader open={acceptLoading} />
      <Modal
        modalName='product-incoming'
        open={open}
        onClose={onClose}
        header={() => (
          <ProductItem
            product={product}
            shouldShowControls={false}
            shouldOpenModal={false}
            isModal={true}
          />
        )}
      >
        <ProductControlSwitcher
          initialContent={() => (
            <Button
              onClick={handleAcceptClick}
              variant='contained'
              color='primary'
              fullWidth
            >
              <FormattedMessage {...messages.accept} />
            </Button>
          )}
          toggleContent={() => (
            <ProductDeclineButton product={product} onModalClose={onClose} />
          )}
        />
      </Modal>
    </>
  )
}

export default ProductIncomingModal
